import { apiClient } from "./api";

export const notificationsService = {
  list: (params = {}) => apiClient.get("/notifications", { params }).then((r) => r.data),
  unreadCount: () => apiClient.get("/notifications/unread-count").then((r) => r.data),
  markRead: (id) => apiClient.post(`/notifications/${id}/read`).then((r) => r.data),
  markAllRead: () => apiClient.post("/notifications/read-all").then((r) => r.data),
  getPrefs: () => apiClient.get("/me/notification-prefs").then((r) => r.data),
  updatePrefs: (prefs) => apiClient.put("/me/notification-prefs", { prefs }).then((r) => r.data),
};
